<template>
  <!-- 测试用 -->
  <div class="reviewTaskManage mw1340">
    <el-container>
      <headTop :data="'/legislateKnowledgeBase'"></headTop>
      <el-header class="indexBox">
        <div class="search-box">
          <div class="search-b clearfix">
            <el-radio-group v-model="radioDatabase" @change="radioDatabaseFun">
              <template v-for="(item, index) in radioDatabaseAll">
                <el-radio
                  :key="index"
                  :label="item.code"
                  :disabled="item.code == 'innerdata'"
                  >{{ item.database }}</el-radio
                >
              </template>
            </el-radio-group>
          </div>
          <div class="search-t clearfix">
            <el-input
              placeholder="请输入检索内容"
              v-model="inputTxt"
              class="input-with-select fl"
              ref="ipt"
              @keyup.enter.native="searchFun"
            >
              <el-select v-model="selectTxt" slot="prepend" placeholder="请选择">
                <el-option
                  v-for="(item, index) in selectData"
                  :key="index"
                  :label="item.brief"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-button
                slot="append"
                icon="el-icon-search"
                @click.native="searchFun"
              ></el-button>
            </el-input>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside class="el-aside-l-wrap por" v-loading="loadingTree">
          <a
            @click="showL = !showL"
            class="poa btn-l btn-switch"
            :class="{ cur: showL }"
          ></a>
          <transition name="el-zoom-in-left">
            <div class="el-aside-l por transition-box" v-show="showL">
              <div class="recordReview-l por recordReview-l-index">
                <div class="recordReview-l-treeCon shadowlaw">
                  <el-radio-group v-model="radioTree" @change="radioChangeTreeData">
                    <el-radio-button
                      v-for="(item, index) in treeDataAll"
                      :key="index"
                      :label="item.id"
                      :style="{ width: 100 / treeDataAll.length + '%' }"
                      >{{ item.brief }}</el-radio-button
                    >
                  </el-radio-group>
                  <el-collapse v-model="activeNames">
                    <!-- :title="title" -->
                    <el-collapse-item name="1">
                      <happy-scroll
                        size="3"
                        color="#c1c4c6"
                        :hide-horizontal="true"
                        resize
                      >
                        <!-- :default-expanded-keys="[1]"
												:default-checked-keys="[5]" @check-change="
															handleNodeClick
														"-->

                        <div>
                          <el-tree
                            :data="treeData"
                            node-key="id"
                            :current-node-key="currentKey"
                            :props="defaultProps"
                            @node-click="handleNodeClick"
                            ref="tree"
                            check-on-click-node
                            check-strictly
                            :default-expanded-keys="defaultkey"
                          >
                            <span class="span-ellipsis" slot-scope="{ node }">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                :content="contentHover"
                                placement="top-start"
                                :disabled="isShowTooltip"
                              >
                                <span
                                  @mouseover="onMouseOver(node.label)"
                                  :ref="node.label"
                                  >{{ node.label }}</span
                                >
                              </el-tooltip>
                            </span>
                          </el-tree>
                        </div>
                      </happy-scroll>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </div>
          </transition>
        </el-aside>
        <el-main class="recordReview-c-wrap recordReview-c-wrap-index">
          <div class="shadowlaw recordReview-c por clearfix">
            <div class="areaRight" v-loading="loading">
              <div
                class="areaRight-item"
                v-if="firstTitleData && firstTitleData.length > 0"
              >
                <!-- 一级标签 -->
                <el-radio-group v-model="radio" @change="radioChange()">
                  <el-radio-button
                    v-for="(item, index) in firstTitleData"
                    :key="index"
                    :label="item.id"
                    :style="{
                      width: 100 / firstTitleData.length + '%',
                    }"
                    >{{ item.brief }}</el-radio-button
                  >
                </el-radio-group>
              </div>
              <div class="law2Con">
                <!-- 二级标签 -->
                <div
                  class="nav-item-box"
                  v-if="secondTitleData && secondTitleData.length > 0"
                >
                  <vue-seamless-scroll
                    :class-option="optionSwitch1"
                    class="seamless-warp3"
                    :data="secondTitleData"
                    :key="radio"
                  >
                    <ul class="item clearfix" :style="{ width: itemWidth * num + 'px' }">
                      <li
                        v-for="(item, index) in secondTitleData"
                        :key="index"
                        @click="getidFun(item.id, index)"
                        :class="{ cur: index == cur }"
                      >
                        {{ item.brief }}
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                  <!-- <div class="seamless-warp3">
										<ul class="item clearfix">
											<li
												v-for="(
													item, index
												) in secondTitleData"
												:key="index"
												@click="
													getidFun(item.code, index)
												"
												:class="{ cur: index == cur }"
											>
												{{ item.title }}
											</li>
										</ul>
									</div> -->
                </div>
                <div class="comLaw2">
                  <div class="resultListOperate clearfix">
                    <!--div class="fl">已选：{{ multipleSelection.length }}</div>
                    <div class="fl empty" @click="delCheckedFun">清除</div-->
                  </div>
                  <div class="resultListbox">
                    <!-- 表格 height="getHeight()"-->
                    <el-table
                      ref="multipleTable"
                      :data="searchData"
                      tooltip-effect="dark"
                      style="width: 100%"
                      border
                      class="innerExpertTable"
                      @selection-change="selectionChange"
                      :row-key="getRowKey"
                      :class="{
                        haveSec: secondTitleData && secondTitleData.length > 0,
                        noSec: secondTitleData && secondTitleData.length == 0,
                      }"
                      min-height="260px"
                      :key="radio2"
                    >
                      <!--el-table-column
                        type="selection"
                        width="40"
                        :reserve-selection="true"
                      ></el-table-column-->
                      <el-table-column
                        type="index"
                        width="60"
                        align="center"
                        label="序号"
                        show-overflow-tooltip
                        :index="indexMethod"
                      ></el-table-column>
                      <el-table-column
                        :label="item.column_comment"
                        :min-width="item.column_width"
                        align="center"
                        :show-overflow-tooltip="true"
                        v-for="(item, index) in data_column"
                        :key="index"
                      >
                        <template slot-scope="scope">
                          <!-- <router-link target="_blank" :to="'/detail/' +scope.row.file_id" class="title" v-if="item.column_name=='title'">
														{{ scope.row[item.column_name]}}
													</router-link> -->
                          <!-- <a class="title" v-if="item.column_name=='title'" :href="cnkiUrlKnowledge+'/KCMS/detail/detail.aspx?dbcode='+scope.row.dbcode+'&dbname='+scope.row.tables_name+'&filename='+scope.row.files_name" target="_blank">{{ scope.row[item.column_name]}}</a> -->
                          <a
                            v-if="item.column_name == 'title'"
                            @click="
                              jumpDetailsFun(
                                scope.row.dbcode,
                                scope.row.tables_name,
                                scope.row.files_name
                              )
                            "
                            >{{ scope.row[item.column_name] }}</a
                          >
                          <span v-else>{{ scope.row[item.column_name] }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                      class="page clearfix"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="currentPage"
                      :page-size="pageSize"
                      background
                      layout="total ,prev, pager, next,jumper"
                      :total="searchTotal"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
      <el-footer>
        <foot></foot>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contentHover: "", //鼠标悬停后显示的内容
      isShowTooltip: false, //是否关闭提示功能
      lastSearchType: "", //可选项：tree,searchbox
      //检索框====
      inputTxt: "", //input输入的值
      radioDatabase: "all", //检索框上方tab页选中的数据库
      radioDatabaseAll: [], //检索框上方tab页的数据库列表
      selectTxt: "theme", //下拉列表的值 默认选中主题theme
      selectData: [], //检索栏目-下拉框中的值

      //导航====
      //横向导航-start
      num: null, //二级的数量
      cur: Number, //右侧二级导航当前index
      radio: "", //右侧一级标签选中
      radio2: "", //右侧二级标签选中
      firstTitleData: [], //一级标签数据
      secondTitleData: [], //二级标签数据
      //横向导航-end

      //左侧导航-start
      showL: true, //展开收起
      title: "", //标题 立法知识导航
      radioTree: 3, //导航切换 默认立法领域知识选中 3立法领域知识 1立法业务知识
      treeDataAll: [], //所有左侧导航数据
      activeNames: "1", //当前生效的
      treeData: [],
      defaultProps: {
        children: "children",
        label: "brief",
      },
      currentKey: "", //树形控件-当前选中的节点
      defaultkey: [], //默认选中节点
      checkedTreeObj: {}, //导航树选中的对象
      loadingTree: false, //加载中
      //左侧导航-end
      // 导航结束

      //中间====

      multipleSelection: [], //选中的数据
      currentPage: 1, //表格默认页码
      pageSize: 10, //每页的数量
      searchTotal: 0, //总共条数
      proDate: [], //日期
      isSort: "desc", //默认降序desc 升序asc

      searchData: [], //表格数据
      data_column: [], //表格头部数据
      loading: false, //加载中
      cnkiUrlKnowledge: "", //跳转知网详情

      typeId: Number, //立法知识库导航跳转进来

      itemWidth: Number, //二级标签宽度
    };
  },
  async created() {
    window.localStorage.setItem("headActiveIndex", "/legislateKnowledgeBase");

    console.log("完成检索框上方数据库和检索栏目数据加载");
    await this.getTreeDataFun(this.$route.query.radio);

    if (!window.localStorage.getItem("token")) {
      await this.getDatabaseFun(); //获取检索数据库数据
      await this.getSelectDataFun(); //获取检索栏目数据

      console.log("完成检索框上方数据库和检索栏目数据加载");
      await this.getTreeDataFun(this.$route.query.radio);
      this.lastSearchType = "tree";
      // 首页空检进入时inputTxt为空，自动做tree检索，并选中第一个节点
      this.doRadioChangeTreeData(3);
      this.getTitleDataFun(); //获取横向导航数据

      return;
    }

    if (this.$route.query.radioDatabase) {
      this.radioDatabase = this.$route.query.radioDatabase;
    } else {
      this.radioDatabase = "all";
    }

    //从首页检索跳转过来,做检索框检索
    if (
      this.$route.query.radioDatabase &&
      this.$route.query.inputTxt &&
      this.$route.query.selectTxt
    ) {
      this.inputTxt = this.$route.query.inputTxt;
      this.selectTxt = this.$route.query.selectTxt;
      this.lastSearchType = "searchbox";

      //获取横向导航数据
      this.getTitleDataFun(this.$route.query.radio);
      this.showL = false; //检索时将左侧导航树收起
    }
    //从首页热点专题跳转指定左侧树状导航节点，做树状检索
    else if (this.$route.query.id) {
      this.lastSearchType = "tree";

      let id = parseInt(this.$route.query.id);

      this.currentKey = id;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([id]);
      });
      this.defaultkey = [id];
      this.getTitleDataFun(); //获取横向导航数据
    }
    //从两会热词跳转指定导航节点,暂时不知道是哪里？
    else if (this.$route.query.treeId && this.$route.query.radioTree) {
      this.radioTree = this.$route.query.radioTree;
      this.lastSearchType = "tree";

      let id = parseInt(this.$route.query.treeId);

      this.currentKey = id;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([id]);
      });
      this.defaultkey = [id];

      //this.typeId=parseInt(this.$route.query.typeId);//立法知识库导航跳转进来
      this.getTitleDataFun(); //获取横向导航数据
    }
    //其他情况统一做tree检索
    else {
      this.lastSearchType = "tree";
      // 首页空检进入时inputTxt为空，自动做tree检索，并选中第一个节点
      this.doRadioChangeTreeData(3);
      this.getTitleDataFun(); //获取横向导航数据
    }

    await this.getDatabaseFun(); //获取检索数据库数据
    await this.getSelectDataFun(); //获取检索栏目数据

  },
  methods: {
    onMouseOver(str) {
      // 内容超出，显示文字提示内容
      const tag = this.$refs[str];
      const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      // console.log('parentWidth',parentWidth);
      // console.log('contentWidth',contentWidth);
      this.isShowTooltip = contentWidth <= parentWidth;
      // 鼠标悬停后显示的内容
      this.contentHover = str;
    },
    //表格中数据跳转详情
    jumpDetailsFun(dbcode, tables_name, files_name) {
      let cnkiHref = "";
      // 政报库跳转链接不一样
      if (this.radio == 5) {
        cnkiHref =
          this.cnkiUrlKnowledge +
          "/urtpweb/detail?sysid=23&resid=1&filename=" +
          files_name +
          "&tablename=" +
          tables_name;
        // //页面中创建一个a，点击跳转
        // let a = document.createElement("a");
        // a.href = cnkiHref;
        // a.target = "_blank";
        // document.body.appendChild(a);
        // a.click(); //点击下载
        // document.body.removeChild(a); //下载完成移除元素
        // this.$router.push("/cnkiDetail?type=3&url=" + encodeURIComponent(cnkiHref));
        window.open(
          "/#/cnkiDetail?b=3&type=3&url=" + encodeURIComponent(cnkiHref),
          "_blank"
        );
      } else {
        cnkiHref =
          this.cnkiUrlKnowledge +
          "/KCMS/detail/detail.aspx?dbcode=" +
          dbcode +
          "&dbname=" +
          tables_name +
          "&filename=" +
          files_name;
        this.$router.push("/#/cnkiDetail?url=" + encodeURIComponent(cnkiHref));
        window.open("/#/cnkiDetail?b=3&url=" + encodeURIComponent(cnkiHref), "_blank");
      }
    },
    //获取横向导航数据,并自动做检索
    //radio为指定一级标签检索,
    getTitleDataFun(radio) {
      this.radio = ""; //请求之前先清空
      let url = "/japi/knowledge/get_horizon_navigation/"; //请求的接口
      let kbase_database = this.radioDatabase; //不同的库

      let params = {
        kbase_database: kbase_database,
      };
      this.axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        console.log("横向导航标签数据======");
        if (res.data.code == 200) {
          this.firstTitleData = []; //清空一级标签数据
          this.secondTitleData = []; //清空二级标签数据

          if (res.data.data.length > 0) {
            this.firstTitleData = res.data.data;
            let flag = this.firstTitleData.findIndex((item) => {
              return item.id == radio;
            });

            //一级标签中是否包含指定一级标签id
            if (radio && flag > -1) {
              this.radio = radio;
            } else {
              this.radio = this.firstTitleData[0].id; //一级标签默认选中
            }
            this.dealSecondTitleDataFun(); //获取二级标签
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },

    //处理数据 获取导航指定id对象
    getChidlren(id, data) {
      let hasFound = false, // 表示是否有找到id值
        result = null;
      let fn = function (data) {
        if (Array.isArray(data) && !hasFound) {
          // 判断是否是数组并且没有的情况下，
          data.forEach((item) => {
            if (item.id === id) {
              // 数据循环每个子项，并且判断子项下边是否有id值
              result = item; // 返回的结果等于每一项
              hasFound = true; // 并且找到id值
            } else if (item.children) {
              fn(item.children); // 递归调用下边的子项
            }
          });
        }
      };
      fn(data); // 调用一下
      return result;
    },
    //获取检索数据库数据
    async getDatabaseFun() {
      let p = new Promise((resolve, reject) => {
        this.axios.get("/japi/knowledge/get_kbase_horizon/").then((res) => {
          console.log("getDatabaseFun finished");
          if (res.data.code == 200) {
            this.radioDatabaseAll = res.data.data;
            this.radioDatabase = res.data.data[0].code; //默认选中第一个，即all
            resolve();
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      });
      return p;
    },
    //获取检索栏目数据
    async getSelectDataFun() {
      let p = new Promise((resolve, reject) => {
        this.axios.get("/japi/knowledge/get_select_column/").then((res) => {
          console.log("getSelectDataFun finished");
          if (res.data.code == 200) {
            this.selectData = res.data.data;
            this.selectTxt = res.data.data[0].code; //默认选中第一个，即theme
            resolve();
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      });
      return p;
    },

    //检索====
    //切换数据库
    radioDatabaseFun(val) {
      console.log(val);
    },
    //点击检索按钮
    searchFun() {
      this.inputTxt = this.inputTxt.trim();
      this.lastSearchType = "searchbox";

      this.searchTotal = 0;
      this.searchData = [];
      this.currentKey = "";
      this.resetTreeData(); //清空导航树
      this.showL = false; //检索时将左侧导航树收起
      this.getTitleDataFun(); //获取横向导航数据
    },
    //检索重置按钮
    resetFun() {
      this.radioDatabase = "all"; //默认全部,包括全部、法律法规、政报公报
      this.selectTxt = "theme"; //下拉列表选中的值
      this.inputTxt = ""; //检索词
      this.pageSize = 10;

      this.searchTotal = 0;
      this.searchData = [];

      // this.search(1);//重置的时候
    },
    //主要的检索功能
    search(page) {
      this.loading = true; //加载中显示
      let url = ""; //请求的接口
      let params = {}; //参数
      let nav_horizon = ""; //一级或二级导航
      //若二级导航不存在 则传一级导航
      if (this.radio2) {
        nav_horizon = this.radio2;
      } else {
        nav_horizon = this.radio;
      }

      //导航树检索
      if (this.lastSearchType == "tree") {
        url = "/japi/knowledge/navigation_select/";

        params = {
          p: page, //页码
          // tag:tag,//是否加载导航 yes是 no否
          nav_tree_id: this.currentKey, //导航id
          nav_horizon: nav_horizon, //横向导航 若二级导航为空则传一级导航
          pn: this.pageSize, //每页数量
        };
      }
      //一框检索
      else if (this.lastSearchType == "searchbox") {
        url = "/japi/knowledge/select/";

        params = {
          p: page, //页码
          // tag:tag,//是否加载导航 yes是 no否
          // kbase_database:this.radioDatabase,//检索数据库
          column: this.selectTxt, //检索栏目
          keyword: this.inputTxt, //检索词
          nav_horizon: nav_horizon, //横向导航 若二级导航为空则传一级导航
          pn: this.pageSize, //每页数量
        };
      }
      this.axios({
        method: "get",
        url: url,
        params: params,
      })
        .then((res) => {
          console.log("检索结果======");
          console.log(res);
          this.loading = false;
          if (res.data.code == 200) {
            if (res.data.data) {
              this.searchTotal = res.data.data.res.sum_count; //总数量
              this.searchData = res.data.data.res.data; //表格数据
              this.data_column = res.data.data.res.data_column; //表格头部数据
              this.cnkiUrlKnowledge = res.data.data.res.url_prefix.trim(); //跳转知网详情
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //左侧导航====
    //只时拉取左侧导航数据
    getTreeDataFun() {
      let p = new Promise((resolve, reject) => {
        this.loadingTree = true;
        this.axios.get("/japi/knowledge/get_navigation/").then((res) => {
          if (res.data.code == 200) {
            this.loadingTree = false;
            console.log("左侧导航数据======");
            this.treeDataAll = res.data.data;
            if (this.radioTree == 3) {
              this.treeData = res.data.data[0].children;
            } else if (this.radioTree == 1) {
              this.treeData = res.data.data[1].children;
            }
            resolve();
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      });
      return p;
    },
    doRadioChangeTreeData(val) {
      this.resetFun(); //检索重置
      this.delCheckedFun(); //表格清空选中功能

      //3立法领域知识 1立法业务知识
      if (val == 3) {
        this.treeData = this.treeDataAll[0].children;

        //获取导航第一末级节点选中的id
        let id = Number;
        //一级标签是否有下一级 true存在 false不存在
        console.log(this.treeData[0]);
        if (this.treeData[0].disabled) {
          //二级标签是否有下一级 true存在 false不存在
          if (this.treeData[0].children[0].disabled) {
            id = this.treeData[0].children[0].children[0].id;
          } else {
            id = this.treeData[0].children[0].id;
          }
        } else {
          id = this.treeData[0].id;
        }
        console.log(id);
        this.currentKey = id;
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([id]);
        });
        this.defaultkey = [id];
      } else if (val == 1) {
        this.treeData = this.treeDataAll[1].children;

        //获取导航第一末级节点选中的id
        let id = Number;
        //一级标签是否有下一级 true存在 false不存在
        console.log(this.treeData[0]);
        if (this.treeData[0].disabled) {
          //二级标签是否有下一级 true存在 false不存在
          if (this.treeData[0].children[0].disabled) {
            id = this.treeData[0].children[0].children[0].id;
          } else {
            id = this.treeData[0].children[0].id;
          }
        } else {
          id = this.treeData[0].id;
        }
        console.log(id);
        this.currentKey = id;
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([id]);
        });
        this.defaultkey = [id];
      }
    },
    //切换导航树的一级菜单，例如立法业务知识/立法领域知识
    radioChangeTreeData(val) {
      this.lastSearchType = "tree";
      this.doRadioChangeTreeData(val);
      this.search(1); //检索 yes加载横向导航 导航树检索
    },
    //获取导航数据-等待请求完成
    getTreeDataFunWait() {
      let p = new Promise((resolve, reject) => {
        this.axios.get("/japi/knowledge/get_navigation/").then((res) => {
          if (res.data.code == 200) {
            console.log("左侧导航数据======");
            console.log(res);
            this.treeData = res.data.data;
            resolve();
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      });
      return p;
    },
    //重置左侧导航树
    resetTreeData() {
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([]);
      });
      // this.currentKey = Number;
      this.currentKey = "";
      /*this.radioDatabase = "all"; //全部
      this.selectTxt = "theme"; //主题

      this.getTreeDataFun("currentKey"); //获取导航数据 currentKey需要获取导航默认选中
      this.getTitleDataFun("tree"); //获取横向导航数据*/
    },
    //树形控件实现单选功能，只能选择末级节点 data:节点所对应的对象 节点对应的Node 节点组件本身
    handleNodeClick(data, checked, node, type) {
      console.log(data);
      console.log("导航选中的id: " + data.id);
      this.lastSearchType = "tree";
      if (data.children.length == 0) {
        if (type == "index") {
          this.currentKey = data.id;
          this.$refs.tree.setCheckedKeys([data.id]);
          // this.search(1,'yes','tree');//请求数据
          this.getTitleDataFun(); //获取横向导航数据
        } else {
          this.currentKey = data.id;
          this.$refs.tree.setCheckedKeys([data.id]);
          this.resetFun(); //检索重置
          this.delCheckedFun(); //表格清空选中功能
          // this.search(1,'yes','tree');//请求数据
          this.getTitleDataFun(); //获取横向导航数据
        }
      }
    },

    //右侧====
    //序号
    indexMethod(index) {
      //currentPage当前页码 pageSize每页条数
      return index + 1 + (this.currentPage - 1) * this.pageSize;
    },

    //获取二级标签
    dealSecondTitleDataFun(index) {
      //id=2 中央 id=5政报公报时 二级标签的宽度为120，其余为72
      if (this.radio == 2 || this.radio == 5) {
        this.itemWidth = 120;
      } else {
        // this.itemWidth=72;
        this.itemWidth = 86;
      }
      this.radio2 = ""; //请求之前先清空
      this.firstTitleData.forEach((item) => {
        if (item.children && item.children.length > 0) {
          if (this.radio == item.id) {
            this.secondTitleData = item.children;
            this.radio2 = item.children[0].id; //二级标签选中值
            this.cur = 0; //右侧二级导航当前index
          }
        }
      });
      if (this.secondTitleData.length > 0) {
        this.num = this.secondTitleData.length;
      }
      this.delCheckedFun(); //表格清空选中功能
      this.search(1); //检索 yes加载横向导航 导航树检索
    },

    //右侧一级标签切换
    radioChange(val) {
      this.secondTitleData = []; //先清空二级
      this.radio2 = ""; //选完一级标签之后 清空二级标签
      this.cur = Number;
      this.dealSecondTitleDataFun(); //获取二级标签
    },
    //获取右侧二级标签的id
    getidFun(id, index) {
      this.cur = index;
      this.radio2 = id;
      this.currentPage = 1;
      this.delCheckedFun(); //表格清空选中功能
      this.search(1);
    },

    //当表格选择框发生变化时，，获取选中的值
    selectionChange(val) {
      this.multipleSelection = val;
      //this.innerOrgAdd = true;
    },
    //表格清空选中功能
    delCheckedFun() {
      this.multipleSelection = []; //选中的数据
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection(); //清空数据
      });
    },
    //指定一个key标识这一行的数据，跨页获取选中的数据 key必须唯一！！
    getRowKey(row) {
      return row.files_name;
    },

    //分页====
    //每页条数
    handleSizeChange(size) {
      // console.log(`每页 ${size} 条`);
      this.pageSize = size;
      if (this.currentKey) {
        this.search(this.currentPage, "no", "tree"); //检索 yes加载横向导航 导航树检索
      } else {
        this.search(this.currentPage, "no", "retrieve"); //检索 yes加载横向导航  一框检索retrieve
      }
    },
    //当前页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      if (this.currentKey) {
        this.search(this.currentPage, "no", "tree"); //检索 yes加载横向导航 导航树检索
      } else {
        this.search(this.currentPage, "no", "retrieve"); //检索 yes加载横向导航  一框检索retrieve
      }
    },
  },
  computed: {
    //vue-seamless-scroll配置 文字滑动
    optionSwitch1() {
      return {
        autoPlay: false, //自动轮播
        switchSingleStep: 920, //轮播一次的宽度 为一屏的宽度 小于这个值不能滚动
        navigation: true, //左右滚动是否显示控制器按钮
        limitMoveNum: this.secondTitleData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, //往左滚动
        openWatch: true, // 开启数据实时监控刷新dom [ 当数据更新时默认是没有滚动的状态 ]
        //isSingleRemUnit:true //	singleHeight and singleWidth是否开启rem度量
      };
    },
  },
  // watch:{
  // 	'$route':function(){ //解决切换相同路由，只是参数不一样，切换后页面不刷新的问题
  // 		//页面刷新
  // 		this.$router.push("/refresh");
  // 	}
  // }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/mixin.scss"; //定义方法
@import "../../assets/css/recordReviewDetail.scss"; //备案审查详情页样式
.reviewTaskManage {
  background: $bodyColor;
}
// 头部
.header {
  @include theme();
}
.header /deep/ {
  height: 84px !important;
  line-height: 84px;
  .title {
    // @include fontSize($fz24, $num);
    font-size: 36px;
    color: $cfff;
  }
  .welcome {
    @include fontSize($fz12, $num);
    color: $cd0dcfb;
  }
  // 导航
  & > .el-menu {
    background: transparent !important;
    float: left;
    .iconfont {
      position: absolute;
      bottom: 16px;
      left: 50%;
      margin-left: -6px;
      @include fontSize($fz12, $num);
      color: $c7ca1fa;
      line-height: 0px;
      display: none;
    }
    .el-submenu .el-menu-item {
      border-bottom: 1px dashed #d4d2d2;
      &:last-child {
        border: none;
      }
    }
    .el-menu--horizontal {
      left: 4px !important;
      .el-menu-item {
        line-height: 36px;
        height: 36px;
      }
    }
  }
  .el-menu-demo1 {
    margin-left: 6%;
  }
  & > .el-menu > .el-menu-item,
  .el-submenu__title {
    @include fontSize($fz18, $num);
    color: $c7ca1fa;
    position: relative;
  }
  .el-submenu {
    position: relative;
  }
  .el-menu.el-menu--horizontal,
  .el-menu--horizontal > .el-menu-item {
    border: none;
  }
  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 84px;
    line-height: 84px;
    color: $c7ca1fa;
    border-bottom: none;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    position: relative;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    color: $cfff;
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background: transparent;
    color: $cfff;
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
    color: $cfff;
  }
  .el-submenu.is-active {
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  //更多操作
  .el-menu-demo2 {
    float: right;
    margin-right: 3%;
    .iconfont {
      display: block;
      @include fontSize($fz30, $num);
      color: $cfff;
      bottom: 40px;
    }
  }
}
.haveSec {
  height: calc(100vh - 540px);
  overflow-y: auto;
}
.noSec {
  height: calc(100vh - 490px);
  overflow-y: auto;
}

//侧边
// .el-aside {
// 	background-color: #d3dce6;
// 	color: #333;
// 	text-align: center;
// 	line-height: 200px;
// 	overflow: inherit;
// 	min-height: calc(100vh - 210px);
// 	width: 280px;
// 	align-items: stretch;
// 	position: relative;
// }
//中间内容
// .el-main {
// 	background:transparent;
// 	color: #333;
// 	text-align: center;
// 	min-height: calc(100vh - 210px);
// 	h2 {
// 		@include fontSize($fz16, $num);
// 	}
// 	p {
// 		@include fontSize($fz12, $num);
// 	}
// }
// 底部
.el-footer {
  height: auto !important;
  @include theme();
}
</style>
